import { IacAllowedUseCases, Navigator } from '../../third-party/service/navigator'
import * as Logger from '@navigator/frontend-logger'
import { appConfig } from '../config'

export const EVENT_NAME_TRIGGER_IAC = 'triggeriac'

export const initIacDispatcher = () => {
  document.documentElement.addEventListener(EVENT_NAME_TRIGGER_IAC, onCustomEvent)
  window.addEventListener('message', onMessage)
}

/**
 * Handles postMessage events from iframes, e.g. UPP content
 * @param ev
 */
export const onMessage = (ev: MessageEvent) => {
  if (ev.data?.type !== 'iacUsecase') {
    return
  }

  if (!isAllowed(ev.data.name, ev.origin)) {
    Logger.warn(`Origin ${ev.origin} is not allowed to trigger IAC use case ${ev.data.name}`)
    return
  }

  Navigator.dispatchUsecase(ev.data.name, ev.data.payload, ev.data.asRPE)
}

/**
 * Handles triggeriac events fired by web components within the Navigator
 * @param ev
 */
export const onCustomEvent = (ev: CustomEvent) => {
  if (typeof ev.detail?.name === 'string') {
    Navigator.dispatchUsecase(ev.detail.name, ev.detail.payload, ev.detail.asRPE)
  }
}

/**
 * Checks if an iframe origin is allowed to dispatch a given use case
 * @param name IAC use case name
 * @param origin Iframe origin
 */
export const isAllowed = (name: string, origin: string): boolean => {
  const allowedOrigins = getAllowedIacUseCases()[name] || []
  return allowedOrigins.includes(origin) || allowedOrigins.includes('*')
}

export const getAllowedIacUseCases = (): IacAllowedUseCases => {
  return appConfig?.thirdParty?.upp?.iac_allowed_use_cases || {}
}
